import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withKeys as _withKeys, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_3 = { class: "mt-3" }
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "dialog-footer" }

import {
  ref,
  computed,
  onMounted,
  inject,
  watch,
  nextTick,
} from "vue";
import { remarkForApi } from "@/core/helpers/remark";
import ApiService from "@/core/services/Transaction.ts";
import ApiBankService from "@/core/services/Account.ts";
import { LoadingService } from "@/core/plugins/loading";
import { ElNotification } from "element-plus";
import SvgSprite from "@/components/shared/SvgSprite.vue";

import { useRoute, useRouter } from "vue-router";

import PaymentDetail from "@/views/sellstock/transaction/PayDetail";

interface BankOption {
  value: string;
  label: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Pay',
  props: {
  modelValue: Boolean,
},
  setup(__props, { emit: __emit }) {

const route = useRoute();
const router = useRouter();

const $loading = inject("$loading") as LoadingService;

const items = ref([]);
const count = ref(0);
const banks: BankOption[] = [
  { value: "bbl", label: "Bangkok Bank" },
  {
    value: "baac",
    label: "Bank for Agriculture and Agricultural Cooperatives",
  },
  { value: "bay", label: "Bank of Ayudhya" },
  { value: "cimb", label: "CIMB Thai Bank" },
  { value: "gov", label: "Government Savings Bank" }, // gov
  { value: "kbank", label: "Kasikorn Bank" },
  { value: "kk", label: "Kiatnakin Phatra Bank" }, // kk
  { value: "ktb", label: "KTB" },
  { value: "scb", label: "SCB" },
  { value: "ttb", label: "TMB Thanachart Bank" },
  { value: "uobt", label: "United Overseas Bank (Thai)" },
];

const bankRules = ref([(v: string) => !!v || "Bank is required"]);
const fnameRules = ref([(v: string) => !!v || "First Name is required"]);
const lnameRules = ref([(v: string) => !!v || "Last Name is required"]);
const accountNumberRules = ref([
  (v: string) => !!v || "Account Number is required",
  (v: string) =>
    /^[0-9]{1,12}$/.test(v) ||
    "Account number must be numeric and no more than 12 characters.",
]);

const dialogVisible = ref(false);
const dialogData = ref({
  bank: "",
  account_number: "",
  first_name: "",
  last_name: "",
});

const openAddDialog = () => {
  dialogData.value = {
    bank: "",
    account_number: "",
    first_name: "",
    last_name: "",
  };
  dialogVisible.value = true;
};

const closeDialog = () => {
  dialogVisible.value = false;
  dialogData.value = {
    bank: "",
    account_number: "",
    first_name: "",
    last_name: "",
  };
};

const handleSubmit = async () => {
  if (
    !dialogData.value.bank ||
    !dialogData.value.account_number ||
    !dialogData.value.first_name ||
    !dialogData.value.last_name
  ) {
    ElNotification({
      title: "error",
      message: "Please fill in all fields.",
      type: "error",
    });

    return;
  }

  $loading.startLoading();

  try {
    const fullName = `${dialogData.value.first_name} ${dialogData.value.last_name}`;

    const response = await ApiBankService.addAccount({
      bank: dialogData.value.bank,
      account_number: dialogData.value.account_number,
      account_fullname: fullName,
    });

    ElNotification({
      title: "success",
      message: response.message || "Account added successfully!",
      type: "success",
    });

    fetchUserAccounts();
    closeDialog();
  } catch (error) {
    console.error(error);
    ElNotification({
      title: "error",
      message: error.response?.data?.message || "Operation failed.",
      type: "error",
    });
  } finally {
    $loading.endLoading();
  }
};

const selectedPaymentMethod = ref(1);
const selectedAccount = ref("");
const paymentMethods = ref([{ label: "QRCode", value: 1 }]);

const userAccounts = ref("");

const inputAmount = ref("");
const inputRemark = ref("");

const amountInput = ref<HTMLInputElement | null>(null);

const isDialogPayment = ref(false);
const selectedOrder = ref(null);

const props = __props;

const emit = __emit;

const isDialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit("update:modelValue", value);
  },
});

const resetFields = () => {
  selectedPaymentMethod.value = "";
  selectedAccount.value = "";
  inputAmount.value = "";
  inputRemark.value = "";
  isDialogVisible.value = false;
};

const handleDialogClose = () => {
  emit("update:modelValue", false);
  // if (route.path.includes("sellstock/transaction")) {
  //   window.location.reload();
  // }
  resetFields();
};

const fetchUserAccounts = async () => {
  try {
    const resp = await ApiBankService.accountLists();

    if (resp && resp.bank_accounts && Array.isArray(resp.bank_accounts)) {
      let data = resp.bank_accounts;
      userAccounts.value = data.map((account: any) => ({
        label: `${account.account_fullname} - ${account.account_number} (${account.bank})`,
        value: account.id,
      }));
    } else {
      throw new Error("No bank accounts found or invalid response format.");
    }
  } catch (error) {
    ElNotification({
      title: "Error",
      message: error,
      type: "error",
    });
  }
};
watch(selectedPaymentMethod, (newVal) => {
  if (newVal === 1) {
    fetchUserAccounts();
  }
});

const handlePay = (item: any) => {
  isDialogVisible.value = true;
};

const submitPayment = async (order) => {
  $loading.startLoading();
  if (selectedPaymentMethod.value) {
    let payload: any = {
      method: selectedPaymentMethod.value,
    };

    if (selectedPaymentMethod.value === 1) {
      if (!selectedAccount.value) {
        ElNotification({
          title: "Error",
          message: "Please select an account.",
          type: "error",
        });
        $loading.endLoading();
        return;
      }
      payload.bank_account_id = selectedAccount.value;
    }

    if (inputAmount.value < 300 || inputAmount.value > 200000) {
      ElNotification({
        title: "Error",
        message: "Amount must be between 300 and 200,000",
        type: "error",
      });
      $loading.endLoading();
      return;
    }

    payload.amount = parseFloat(inputAmount.value);
    payload.remark = remarkForApi(inputRemark.value);

    const resp = await ApiService.pay(payload);
    if (resp.payment) {
      selectedOrder.value = resp.payment;
      await nextTick();
      isDialogPayment.value = true;
      ElNotification({
        title: "Success",
        message: resp.message,
        type: "success",
      });

      resetFields();
    } else {
      ElNotification({
        title: "Error",
        message: resp.error || resp.msg,
        type: "error",
      });
    }
  } else {
    ElNotification({
      title: "Error",
      message: "Please select a payment method.",
      type: "error",
    });
  }
  $loading.endLoading();
};

const closeUploadDialog = () => {
  isDialogPayment.value = false;
  selectedOrder.value = null;
};

watch(
  () => isDialogVisible.value,
  (newVal) => {
    if (newVal) {
      selectedPaymentMethod.value = 1;
      fetchUserAccounts();
      nextTick(() => {
        const inputEl = amountInput.value?.$el?.querySelector("input");
        if (inputEl) {
          inputEl.focus();
        }
      });
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_label = _resolveComponent("v-label")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: isDialogVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isDialogVisible).value = $event)),
      title: "Payment",
      width: "500",
      "align-center": "",
      "close-on-click-modal": false,
      onClose: handleDialogClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            variant: "flat",
            size: "large",
            rounded: "md",
            type: "danger",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (resetFields()))
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createTextVNode("Cancel")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            variant: "flat",
            size: "large",
            rounded: "md",
            type: "primary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (submitPayment()))
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createTextVNode("Pay ")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_label, null, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createTextVNode("Choose Payment Method")
              ])),
              _: 1
            }),
            _createVNode(_component_el_select, {
              class: "mt-2",
              required: "",
              "hide-details": "auto",
              variant: "outlined",
              color: "primary",
              size: "large",
              modelValue: selectedPaymentMethod.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPaymentMethod).value = $event)),
              placeholder: 'Choose Payment Method',
              outlined: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentMethods.value, (method) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: method.value,
                    label: method.label,
                    value: method.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_v_label, null, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("Please enter an amount")
                ])),
                _: 1
              }),
              _createVNode(_component_v_text_field, {
                modelValue: inputAmount.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputAmount).value = $event)),
                placeholder: "300 - 200,000",
                density: "comfortable",
                required: "",
                "hide-details": "auto",
                variant: "outlined",
                color: "primary",
                maxlength: "10",
                onInput: _cache[2] || (_cache[2] = ($event: any) => (
            inputAmount.value = inputAmount.value
              .replace(/[^0-9.]/g, '')
              .replace(/(\..*)\./g, '$1')
              .slice(0, 10)
          )),
                rules: [
            (v) => !!v || 'Amount is required',
            (v) => {
              const numberValue = parseFloat(v);
              return (
                (numberValue >= 300 && numberValue <= 200000) ||
                'Amount must be between 300 and 200,000'
              );
            },
            (v) =>
              /^\d+(\.\d{1,2})?$/.test(v) ||
              'Amount must be a valid decimal with up to two decimal places',
          ],
                onKeyup: _withKeys(submitPayment, ["enter"])
              }, null, 8, ["modelValue", "rules"])
            ]),
            (selectedPaymentMethod.value === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_alert, {
                      type: "warning",
                      "show-icon": "",
                      class: "mb-4"
                    }, {
                      title: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createElementVNode("div", { class: "fs-8" }, [
                          _createElementVNode("p", null, " Please use only the selected bank account for your transfer. "),
                          _createElementVNode("p", null, "โปรดใช้บัญชีธนาคารที่ท่านเลือกในการโอนเงินเท่านั้น"),
                          _createElementVNode("p", null, "请仅使用您所选择的银行账户进行转账。")
                        ], -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_v_label, null, {
                    default: _withCtx(() => [
                      _cache[17] || (_cache[17] = _createTextVNode("Choose Your Account ")),
                      _createElementVNode("span", {
                        class: "c-pointer text-primary ml-1",
                        onClick: openAddDialog
                      }, " (Or add new one)")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_select, {
                    modelValue: selectedAccount.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedAccount).value = $event)),
                    placeholder: 'Choose Your Account',
                    density: "comfortable",
                    required: "",
                    "hide-details": "auto",
                    variant: "outlined",
                    color: "primary",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userAccounts.value, (account) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: account.value,
                          label: account.label,
                          value: account.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_label, null, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode("Please enter a remark")
                ])),
                _: 1
              }),
              _createVNode(_component_v_text_field, {
                modelValue: inputRemark.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inputRemark).value = $event)),
                placeholder: "Remark",
                class: "mt-2",
                density: "comfortable",
                required: "",
                "hide-details": "auto",
                variant: "outlined",
                color: "primary",
                rules: [(v) => !!v || 'Remark is required'],
                onKeyup: _withKeys(submitPayment, ["enter"]),
                maxlength: "50"
              }, null, 8, ["modelValue", "rules"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dialogVisible).value = $event)),
      title: "Add Account",
      width: "500",
      "align-center": "",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_button, { onClick: closeDialog }, {
            default: _withCtx(() => _cache[25] || (_cache[25] = [
              _createTextVNode("Cancel")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleSubmit
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [
              _createTextVNode(" Add ")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_label, null, {
            default: _withCtx(() => _cache[21] || (_cache[21] = [
              _createTextVNode("Bank")
            ])),
            _: 1
          }),
          _createVNode(_component_el_select, {
            modelValue: dialogData.value.bank,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialogData.value.bank) = $event)),
            placeholder: "Please select a bank",
            size: "large",
            class: "v-input__control",
            rules: bankRules.value,
            required: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(banks, (bank) => {
                return _createVNode(_component_el_option, {
                  key: bank.value,
                  label: bank.label,
                  value: bank.value
                }, null, 8, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue", "rules"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_v_label, null, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [
              _createTextVNode("Account Number")
            ])),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            "aria-label": "account_number",
            modelValue: dialogData.value.account_number,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogData.value.account_number) = $event)),
            maxlength: "12",
            class: "mt-2",
            density: "comfortable",
            variant: "outlined",
            color: "primary",
            rules: accountNumberRules.value,
            required: ""
          }, null, 8, ["modelValue", "rules"])
        ]),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_label, null, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createTextVNode("First Name")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_text_field, {
                  "aria-label": "first_name",
                  modelValue: dialogData.value.first_name,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dialogData.value.first_name) = $event)),
                  class: "mt-2",
                  density: "comfortable",
                  variant: "outlined",
                  color: "primary",
                  rules: fnameRules.value,
                  required: ""
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_label, null, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createTextVNode("Last Name")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_text_field, {
                  "aria-label": "last_name",
                  modelValue: dialogData.value.last_name,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dialogData.value.last_name) = $event)),
                  class: "mt-2",
                  density: "comfortable",
                  variant: "outlined",
                  color: "primary",
                  rules: lnameRules.value,
                  required: ""
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(PaymentDetail), {
      modelValue: isDialogPayment.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((isDialogPayment).value = $event)),
      selectedOrder: selectedOrder.value
    }, null, 8, ["modelValue", "selectedOrder"])
  ], 64))
}
}

})